export default "__VITE_ASSET__739e876a__"